module.exports = __webpack_public_path__ + "img/start-2.02b10133.png";